/// <reference lib="webworker" />

// addEventListener('message', ({ data }) => {
//   const response = `worker response to ${data}`;
//   postMessage(response);
// });

/// <reference lib="webworker" />

addEventListener('message', ({ data }) => {
  if (!data.apiUrl) return;

  // Construct request options
  const requestOptions: RequestInit = {
    method: data.method || 'GET', // Default to GET, allow overriding
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${data.token}` // Pass the Bearer token
    },
    body: data.method === 'POST' || data.method === 'PUT' ? JSON.stringify(data.body) : null
  };

  // Make the API call
  fetch(data.apiUrl, requestOptions)
    .then(response => response.json())
    .then(result => postMessage(result))
    .catch(error => postMessage({ error: error.message }));
});


